import React, {useEffect, useState} from 'react';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import {enums} from "../utils/enums";
import {createUserWithEmailAndPassword} from "firebase/auth";
import {auth, db} from "../utils/firebaseApp";
import {collection, doc, getDoc, getDocs, query, setDoc} from "firebase/firestore";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import {toast} from "react-toastify";
import Typography from "@mui/material/Typography";
import {Header} from "../shared-components/Header";

const GodPage = () => {
    const [password, setPassword] = useState("");
    const [email, setEmail] = useState("");
    const [role, setRole] = useState("");
    const [events, setEvents] = useState([])
    const [eventName, setEventName] = useState("")
    const [selectedEvent, setSelectedEvent] = useState("")

    useEffect(() => {
        async function getEvents() {
            const q = query(collection(db, "events"));

            const querySnapshot = await getDocs(q);
            const events = []
            querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                console.log(doc.id, " => ", doc.data());
                events.push(doc.data())
            });

            setEvents(events)
        }

        getEvents()
    }, [])

    async function createEvent() {
        const uid = crypto.randomUUID()
        try {
            await setDoc(doc(db, "events", uid), {
                name: eventName.toLowerCase(),
                displayName: eventName,
                date: Date.now(),
                uid: uid,
                users: [],
                logo: 'https://via.placeholder.com/300',
            });
            window.location.reload();
            toast.success('Event created')
        } catch (e) {
            console.log(e)
            toast.error('Event creation failed')
        }
    }

    function createUser() {
        createUserWithEmailAndPassword(auth, email, password)
            .then(async (userCredential) => {
                const user = userCredential.user;
                console.log(user)
                await setDoc(doc(db, "users", auth.currentUser.uid), {
                    uid: user.uid,
                    joined: Date.now(),
                    role: role,
                    email: email,
                    event: selectedEvent
                });
                toast.success('User created')
            })
            .catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                toast.error(errorMessage)
                // ..
            });
    }

    return (
        <>
            <Header/>
            <Grid container direction={'column'} spacing={2} p={2}>
                <Grid item>
                    <Typography variant={'h1'}>GOD MODE</Typography>
                </Grid>

                <Grid item xs={12}>
                    <Typography variant={'h4'}>Add event</Typography>
                    <Stack sx={{maxWidth: '500px'}}>
                        <TextField
                            value={eventName}
                            onChange={e => setEventName(e.target.value)}
                            margin="normal"
                            required
                            id="event"
                            label="event"
                            name="event"
                        />
                    </Stack>
                    <Button variant={'contained'} onClick={() => createEvent()}>Create event</Button>
                </Grid>


                <Grid item xs={12}>
                    <Typography variant={'h4'}>Dodaj Korisnike</Typography>
                    <Stack sx={{maxWidth: '500px'}}>
                        <TextField
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            margin="normal"
                            required
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            autoFocus
                        />
                        <TextField
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            margin="normal"
                            required
                            name="password"
                            label="Password"
                            id="password"
                        />

                        <FormControl>
                            <InputLabel id="demo-simple-select-label">Role</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={role}
                                label="Age"
                                onChange={e => setRole(e.target.value)}
                            >
                                <MenuItem value={enums.BARTENDER}>BARTENDER</MenuItem>
                                <MenuItem value={enums.BANKER}>BANKER</MenuItem>
                                <MenuItem value={enums.VALIDATOR}>VALIDATOR</MenuItem>
                                <MenuItem value={enums.ADMIN}>ADMIN</MenuItem>
                            </Select>
                        </FormControl>

                        {role === enums.ADMIN ? <FormControl>
                                <InputLabel id="demo-simple-select-label">Event</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedEvent}
                                    label="Event"
                                    onChange={e => setSelectedEvent(e.target.value)}
                                >
                                    {events.map(event => <MenuItem value={event.uid}>{event.name}</MenuItem>)}
                                </Select>
                            </FormControl>
                            : null}

                        <Button variant={'contained'} onClick={() => createUser()}>Dodaj korisnika</Button>
                    </Stack>
                </Grid>
            </Grid>
        </>

    );
};

export default GodPage;
